import React from 'react';

interface PillProps {
  className?: string;
  href?: string;
  icon?: string;
  onClick?: () => void;
  text: string;
}

export default function Pill({ className = '', text, icon, href, onClick }: PillProps) {
  const pillJSX = (
    <>
      <span className="pill-text">{text}</span>
      {icon && <img src={icon} className="link-icon" />}
    </>
  );

  return href || onClick ? (
    <a href={href} onClick={onClick} className={`Pill is-link ${className}`}>
      {pillJSX}
    </a>
  ) : (
    <span className={`Pill ${className}`}>{pillJSX}</span>
  );
}
